export default "__VITE_ASSET__Bo2994GD__"